
export const baseUrl = 'api/'
export const uploadUrl = `${baseUrl}visitsAdmin/cloudService/web/public/uploadFtp.do`